import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ec5330a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "options-list bagsize-options"
}
const _hoisted_2 = { class: "summary-col" }
const _hoisted_3 = { class: "options-list bagsize-options" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-col" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "button edit-button" }, "編集する")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bagsize-note hide-mobile" }, [
  /*#__PURE__*/_createTextVNode(" ※シミュレータは12.5cmのワイドタイプを表示しています。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※シミュレータ上ではランドセルの大きさは変化しません。"),
  /*#__PURE__*/_createElementVNode("br")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormOption = _resolveComponent("FormOption")!
  const _component_FormTab = _resolveComponent("FormTab")!

  return (_openBlock(), _createBlock(_component_FormTab, {
    class: "bagsize-content",
    index: _ctx.index
  }, {
    default: _withCtx(() => [
      (!_ctx.currentSelection)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
              return (_openBlock(), _createBlock(_component_FormOption, {
                optionType: 'bagsize',
                key: item.id,
                option: item,
                onClick: _ctx.openBagtypeDialog,
                isSelected: false
              }, null, 8, ["option", "onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentSelection)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "bagsize-summary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBagtypeDialog && _ctx.openBagtypeDialog(...args)))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("ul", _hoisted_3, [
                _createVNode(_component_FormOption, {
                  optionType: 'bagsize',
                  option: _ctx.currentSelection,
                  onClick: _ctx.openBagtypeDialog,
                  isSelected: false
                }, null, 8, ["option", "onClick"])
              ])
            ]),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      _hoisted_5
    ]),
    _: 1
  }, 8, ["index"]))
}